import OrganizationContainer from './organization_container';

const Organization = OrganizationContainer;
export default Organization;
